
import qrcode from "qrcode";
import { mapState } from "vuex";
import { State } from "@/store";

export default {
    name: "HomeDesktop",
    data() {
        return {
            hasExperience: false,
            experienceId: "",
            videoName: "",
            error: "",
            qrcodeReady: false,
            currentUrl: document.location.href,
            isPlayingVideo: false
        };
    },

    computed: {
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject,
            videoUrl: (state: State) => state.qrcode.videoUrl,
            logoB64: (state: State) => state.qrcode.logoB64
        })
    },

    beforeMount() {
        // this.hasExperience = this.qrcodeObject.experiences?.length > 0;
        // this.videoName =
        //     this.qrcodeObject.experiences.length > 0
        //         ? this.qrcodeObject.experiences[0].name
        //         : this.$t("share.openText");
    },

    mounted() {
        qrcode.toCanvas(this.$refs.canvas, document.location.href, { width: 200 }, error => {
            if (error) {
                console.log("error");
                return;
            }

            this.qrcodeReady = true;
        });

        const videoHome = this.$refs.homeVideo;
        if (videoHome) {
            videoHome.removeEventListener("play", this.onVideoPlay);
            videoHome.removeEventListener("pause", this.onVideoStop);

            videoHome.addEventListener("play", this.onVideoPlay);
            videoHome.addEventListener("pause", this.onVideoStop);
        }
    },

    methods: {
        onVideoPlay() {
            this.isPlayingVideo = true;
        },
        onVideoStop() {
            this.isPlayingVideo = false;
        },
        togglePlay() {
            if (this.isPlayingVideo) {
                this.$refs.homeVideo.pause();
            } else {
                this.$refs.homeVideo.play();
            }
        },
        goFullscreen() {
            this.$refs.homeVideo.requestFullscreen();
        }
    }
};
